<div
  class="form"
  id="form"
  data-aos="fade-down"
  data-aos-duration="600"
  data-aos-delay="100"
>
  <div class="container">
    <div class="form__whole d-flex flex-column flex-xl-row">
      <div class="form__content col-xl-7">
        <div class="form__content-title">
          {{ config().titleSlogan }}
        </div>
        @if (config().slogan) {
        <p class="form__content-text _1r">
          {{ config().slogan }}
        </p>
        }
        <form class="form__content-fill" #contactForm="ngForm">
          <div class="form__content-fill-input">
            <input
              type="text"
              class="form-control form__blank-input"
              [(ngModel)]="formValue.name"
              name="name"
              pattern="^(?:[A-Za-z'-]+(?:\s|$))+[A-Za-z'-]*$"
              required
              placeholder="Full name *"
              [disabled]="!!(isLoading$ | async)"
            />
            @if ( contactForm.controls['name'] && contactForm.touched &&
            contactForm.controls['name'].invalid ) {
            <span class="form__content--invalid">
              We would like to know your name.
            </span>
            }
          </div>
          <div class="form__content-fill-group d-flex flex-column flex-md-row">
            <div class="form__content-fill-input col-12 col-md-6">
              <input
                type="email"
                class="form-control form__blank-input"
                [(ngModel)]="formValue.email"
                name="email"
                pattern="^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$"
                required
                placeholder="E-mail *"
                [disabled]="!!(isLoading$ | async)"
              />
              @if ( contactForm.controls['email'] && contactForm.touched &&
              contactForm.controls['email'].invalid ) {
              <span class="form__content--invalid">
                Please provide your valid email address.
              </span>
              }
            </div>
            <div
              class="form__content-fill-input form__content-fill-input--space col-12 col-md-6"
            >
              <input
                type="email"
                class="form-control form__blank-input"
                [(ngModel)]="formValue.phoneNumber"
                name="phoneNumber"
                placeholder="Phone number (optional)"
                [disabled]="!!(isLoading$ | async)"
              />
            </div>
          </div>
          <div class="form__content-fill-input">
            <textarea
              class="form-control form__blank-input"
              [(ngModel)]="formValue.message"
              [disabled]="!!(isLoading$ | async)"
              name="message"
              rows="3"
              placeholder="Message"
            ></textarea>
          </div>

          <div class="input-group">
            <div
              class="form-control form__content-fill-file"
              (click)="fileUpload.click()"
              [ngClass]="{
                'form__content-fill-file--disabled': !!(isLoading$ | async)
              }"
            >
              {{ fileUploadText }}
            </div>
            <input
              type="file"
              class="form__content-fill-file--hidden"
              [(ngModel)]="formValue.fileUpload"
              name="fileUpload"
              #fileUpload
              aria-describedby="inputGroupFileAddon04"
              aria-label="Upload"
              (change)="onFileSelected($event)"
            />
            <i class="form__content-fill-file-icon ri-attachment-line"></i>
          </div>
          <div class="form__content-agreement col-12">
            <div class="form-check">
              <input
                class="form__content-agreement-check form-check-input"
                type="checkbox"
                [(ngModel)]="formValue.agreement"
                name="agreement"
                required
                [disabled]="!!(isLoading$ | async)"
              />
              @if ( contactForm.controls['agreement'] && contactForm.touched &&
              contactForm.controls['agreement'].invalid ) {
              <span class="form__content--invalid">
                We won`t be able to contact you without this consent.
              </span>
              }

              <label class="form-check-label">
                <p class="form__content-agreement-text _3r">
                  We will use your information to contact you directly about
                  potential cooperation opportunities now or in the future. All
                  the details about personal data protection can be found in the
                  Privacy policy
                </p>
              </label>
              <div class="invalid-feedback">
                You must agree before submitting.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form__content-captcha col-12 col-md-6 pt-0">
              <re-captcha
                [siteKey]="siteKey"
                [(ngModel)]="formValue.captcha"
                name="recaptcha"
              ></re-captcha>
              @if ( contactForm.controls['recaptcha'] &&
              contactForm.controls['recaptcha'].invalid &&
              contactForm.controls['recaptcha'].hasError('required') &&
              contactForm.controls['recaptcha'].touched ) {
              <span class="form__content--invalid">This field is required</span>
              }
            </div>
            <div
              class="col-12 col-md-6 d-flex justify-content-center position-relative"
            >
              <button
                class="btn btn-secondary justify-content-center form__submit-btn"
                [disabled]="!contactForm.valid || (isLoading$ | async)"
                (click)="onFormSubmit()"
              >
                Send a message
              </button>
              @if (config().errorMessage) {
              <p
                class="form__content-api-response form__content-api-response--error _1r form__content-api-response--hidden"
                [ngClass]="{
                  'form__content-api-response--visible':
                    (isErrorVisible$ | async)
                }"
              >
                {{ config().errorMessage }}
              </p>
              } @if (config().successMessage) {
              <p
                class="form__content-api-response form__content-api-response--success _1r form__content-api-response--hidden"
                [ngClass]="{
                  'form__content-api-response--visible':
                    (successResponse$ | async)
                }"
              >
                {{ config().successMessage }}
              </p>
              }
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="form__photo-container">
    <div class="form__photo">
      <img
        [ngSrc]="'../../../assets/img/' + config().imgUrl + '.webp'"
        width="440"
        height="650"
        [alt]="config().altDescription"
        class="form__photo-ceo"
      />

      <div class="form__photo-box">
        <div class="form__photo-box-icon">
          <a
            class="form__photo-box-icon-link"
            [href]="config().linkedIn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              ngSrc="./assets/icons/linkedin.svg"
              width="34"
              height="34"
              alt="Linkedin icon"
              class="form__photo-box-icon-img"
            />
          </a>
        </div>
        <p class="form__photo-box-caption display display-2b">
          {{ config().name }}
        </p>
        <p class="form__photo-box-caption display display-captions-s">
          {{ config().position }}
        </p>
        <a [href]="'mailto:' + config().mailTo" class="form__photo-box-mail">
          {{ config().mailTo }}
        </a>
      </div>
    </div>
  </div>
</div>
